import styled from '@emotion/styled';

const DeleteButton = styled.button`
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.errorColor};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 18px;
  cursor: pointer;
  margin-top: 32px;
  margin-bottom: 8px;
`

DeleteButton.defaultProps = {
  type: 'button',
}

export default DeleteButton;
